module.exports = __webpack_public_path__ + "static/media/blueStairsUp.fb70c504.svg";